export type FieldError = string | string[];

export type ApiErrorPayload = {
  message: string;
  status?: number;
  data?: unknown;
  errors?: Record<string, FieldError>;
  errorCode?: string;
  errorName?: string;
  requestId?: string;
};

export type ApiErrorResponse<T = unknown> = {
  message?: string;
  errorMessage?: string;
  errorCode?: string;
  errorName?: string;
  error?: string;
  errors?: Record<string, FieldError>;
  statusCode?: number;
  data?: T;
};

export class ApiError extends Error {
  status?: number;
  data?: unknown;
  errors?: Record<string, FieldError>;
  errorCode?: string;
  errorName?: string;
  requestId?: string;

  constructor({
    message,
    status,
    data,
    errors,
    errorCode,
    errorName,
    requestId,
  }: ApiErrorPayload) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
    this.errors = errors;
    this.errorCode = errorCode;
    this.errorName = errorName;
    this.requestId = requestId;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export const isApiError = (error: unknown): error is ApiError =>
  error instanceof ApiError;

export const isUnauthorizedError = (error: unknown) =>
  isApiError(error) && error.status === 401;

export type ApiPaginationMeta = {
  total: number;
  perPage: number;
  currentPage: number;
  lastPage: number;
};

export type ApiListResponse<T> = {
  data: T[];
  meta?: ApiPaginationMeta;
};
